import config from '@/configs'

const { availableLocales, fallbackLocale } = config.locales

function findTranslation(translations, translationCodes) {
  return translations.find(t => translationCodes.includes(t?.languages_code ?? t?.language))
}

function getTranslation(locale, obj) {
  if (!obj?.translations?.length) return null

  const localeConfig = availableLocales.find(({ code }) => code === locale)
  if (!localeConfig) return null

  const result = findTranslation(obj.translations, localeConfig.translationCodes)
  if (result) return result

  if (locale !== fallbackLocale) {
    const fallbackConfig = availableLocales.find(({ code }) => code === fallbackLocale)
    if (fallbackConfig) {
      return findTranslation(obj.translations, fallbackConfig.translationCodes) || null
    }
  }

  return null
}

export default {
  install(Vue) {
    Vue.prototype.$dt = function (obj, field) {
      const translation = getTranslation(this.$i18n.locale, obj)
      if (field) return translation?.[field] ?? null
      return translation
    }
  }
}
